module.exports = __webpack_public_path__ + "media/bootstrap-icons/bell-slash-2b46d6d5.svg";